import axios from 'axios';
import queryString from 'query-string';
import {BehaviorSubject} from "rxjs";
import appEnv from "../../../AppEnv";
import {logoutAuthorized} from "../../../_helpers/HNTUtil";

const currentUserSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('currentUser')));

export const axiosClient = axios.create({
  baseURL: appEnv.HOST_SERVICE_JAVA,
  timeout: appEnv.TIME_OUT,
  headers: {
    'Content-type': 'application/json',
  },
  paramsSerializer: params => queryString.stringify(params)
});


axiosClient.interceptors.request.use(async (config) => {
  let token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token.toString()}`;
  }
  return config;
});


axiosClient.interceptors.response.use((response) => {
  if (response && response.hasOwnProperty('data')) {
    return response.data;
  }

  return response;
}, (error) => {
  if (error.response && error.response.status) {
    if ([401, 403].indexOf(error.response.status) !== -1) {
      //logoutAuthorized();
      console.warn('Auto logout with error code 401 Unauthorized or 403 Forbidden response returned from api');
    }
    throw {
      code: error.response.status,
      statusText: error.response.statusText,
      message: error.response.data.message
    }
  }

  if (error.message === 'Network Error') {
    throw {
      code: 500,
      message: 'Service APIs unavailable'
    }
  }

  if (error.response && error.response.data) {
    throw error.response.data;
  }
  throw error.response.data;
});


export function parseErrorApi (error) {
  if (error.response && error.response.data && error.response.data.message) {
    return error.response.data.message;
  }
  if (error.response && error.response.status) {
    if ([401, 403].indexOf(error.response.status) !== -1) {
      return 'You must log in to continue';
    }
  }

  if (typeof error === 'string') {
    return error;
  }
  return error.track ? error.track : (error.message ? error.message : error.toString());
}


export const getMessageError = parseErrorApi;


const getToken = () => localStorage.getItem('token');



export function isUnauthorized(error) {
  return error && error.response && error.response.status &&  [401, 403].indexOf(error.response.status) !== -1;
}

export default axiosClient;
